import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { ApiResponse } from "@/utils/ApiResponse";
import { ProductoInterface } from "../../interfaces/productoInterfaces/Producto.interface";
import { useToast } from "vue-toastification";
import { UpdateProductoParams } from "../../interfaces/productoInterfaces/ProductoUpdateParams";
import { UpdateProductoAction } from "../../actions/productoActions/UpdateProductoAction";
import { invalidateDashboardQueries } from "@/utils/helper/invalidateDashboard";
import { messageFromApiFailure } from "@/utils/apiErrorHandler";

const toast = useToast();

export function useProductoUpdate(onClose?: () => void) {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({ idProducto, formData }: UpdateProductoParams) =>
      UpdateProductoAction(idProducto, formData),

    onSuccess: async (
      response: ApiResponse<ProductoInterface>,
      variables
    ) => {
      // Eliminar cachÃ© del producto individual (find one)
      queryClient.removeQueries({
        queryKey: ["ProductoFindOne", variables.idProducto],
      });

      //Invalidar la lista completa de productos
      await queryClient.invalidateQueries({
        queryKey: ["ProductosList"],
      });

      toast.success("Producto actualizado correctamente");
  // âœ… Invalidar todo el dashboard
      await invalidateDashboardQueries(queryClient);
      //Cerrar modal si se envÃ­a callback
      if (onClose) onClose();
    },

    onError: (error: unknown) => {
      const msg = messageFromApiFailure(error, "Error al actualizar el producto");
      toast.error(msg, { timeout: 9000 });
    },
  });

  return {
    ...mutation,
  };
}
